import React, {FC, useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {ErrorMessage, Field} from 'formik'
import {ICreateAccount, inits as initialValues} from '../CreateAccountWizardHelper'
import CustomerIsAnInternalRank from './OtherInfor/CustomerInternalRank'
import CustomerIsAnInternalRankOwnHave5 from './OtherInfor/CustomerIsAnInternalRankOwnHave5'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const Step10: any = ({setFieldValue}: any) => {
  const data = initialValues
  const [selectedCustomerIsInternal, setSelectedCustomerIsInternal] = useState(
    data.customerIsAnInternal
  )
  const [selectedCustomerOwnHave5, setSelectedCustomerOwnHave5] = useState(data.customersOwnHave5)
  const [selectedCustomerInforOwn, setSelectedCustomerInforOwn] = useState(
    data.informationAboutoOners
  )
  const [valueBirth, setValueBirth] = useState()
  const [valueBoIss, setValueBoIss] = useState()

  const handleCheckedCustomer = (e: any) => {
    setSelectedCustomerIsInternal(e.target.checked)
  }

  const handleCheckedCustomerOwnHave5 = (e: any) => {
    setSelectedCustomerOwnHave5(e.target.checked)
  }

  const handleCheckedInfowOwn = (e: any) => {
    setSelectedCustomerInforOwn(e.target.checked)
  }

  const handleChangeBirth = (val: any) => {
    setValueBirth(val)
  }

  const handleChangeBoIss = (val: any) => {
    setValueBoIss(val)
  }

  useEffect(() => {
    if (!selectedCustomerIsInternal) {
      setFieldValue('internal_cpny_nm_1', undefined)
      setFieldValue('internal_cpny_nm_2', undefined)
      setFieldValue('internal_cpny_nm_3', undefined)
      setFieldValue('internal_stk_1', undefined)
      setFieldValue('internal_stk_2', undefined)
      setFieldValue('internal_stk_3', undefined)
      setFieldValue('internal_position_1', undefined)
      setFieldValue('internal_position_2', undefined)
      setFieldValue('internal_position_3', undefined)
    }
  }, [selectedCustomerIsInternal, setFieldValue])

  useEffect(() => {
    if (!selectedCustomerOwnHave5) {
      setFieldValue('own_cpny_nm_1', undefined)
      setFieldValue('own_cpny_nm_2', undefined)
      setFieldValue('own_cpny_nm_3', undefined)
      setFieldValue('own_stk_1', undefined)
      setFieldValue('own_stk_2', undefined)
      setFieldValue('own_stk_3', undefined)
      setFieldValue('own_position_1', undefined)
      setFieldValue('own_position_2', undefined)
      setFieldValue('own_position_3', undefined)
    }
  }, [selectedCustomerOwnHave5, setFieldValue])

  useEffect(() => {
    if (!selectedCustomerInforOwn) {
      setFieldValue('bo_fullname', undefined)
      setFieldValue('bo_dob', undefined)
      setFieldValue('bo_nationality', undefined)
      setFieldValue('bo_idno', undefined)
      setFieldValue('bo_idno_iss_dt', undefined)
      setFieldValue('bo_idno_iss_orga', undefined)
      setFieldValue('bo_home_addr', undefined)
      setFieldValue('bo_conct_addr', undefined)
      setFieldValue('bo_job', undefined)
      setFieldValue('bo_position', undefined)
      setFieldValue('bo_phone_no', undefined)
      setFieldValue('bo_visa_no', undefined)
      setFieldValue('bo_visano_iss_orga', undefined)
      setFieldValue('bo_foreign_residence', undefined)
    }
  }, [selectedCustomerInforOwn, setFieldValue])

  return (
    <div className='w-100'>
      <div className='w-100'>
        <div className='pb-5 pb-lg-5'>
          <h2 className='fw-bolder text-primary text-center'>Thông tin khác</h2>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Mục tiêu đầu tư</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='ivmt_goal_tp' value='1' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Tăng trưởng dài hạn</span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='ivmt_goal_tp' value='2' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>
                    Tăng trưởng trung hạn
                  </span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='ivmt_goal_tp' value='3' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>
                    Tăng trưởng ngắn hạn
                  </span>
                </span>
              </span>
            </label>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Mức độ chấp nhận rủi ro</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='risk_tp' value='1' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Thấp</span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='risk_tp' value='2' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Trung bình</span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='risk_tp' value='3' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Cao</span>
                </span>
              </span>
            </label>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Kinh nghiệm, kiến thức về đầu tư</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='exp_yn' value='Y' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Có</span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='exp_yn' value='N' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Không</span>
                </span>
              </span>
            </label>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>
              Khách hàng là người nội bộ hoặc người có liên quan của người nội bộ tại công ty đại
              chúng
            </label>
            <div className=''>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  type='checkbox'
                  name='customerIsAnInternal'
                  className='form-check-input w-45px h-30px'
                  onClick={handleCheckedCustomer}
                />
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
          {selectedCustomerIsInternal === true && (
            <>
              <CustomerIsAnInternalRank />
            </>
          )}
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>
              Khách hàng sở hữu từ 5% cổ phiếu có quyền biểu quyết tại công ty đại chúng
            </label>
            <div className='d-flex align-items-center'>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  type='checkbox'
                  name='customersOwnHave5'
                  className='form-check-input w-45px h-30px'
                >
                  {({field, form: {touched, errors}}: any) => (
                    <input
                      className='form-check-input w-45px h-30px'
                      {...field}
                      type='checkbox'
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        handleCheckedCustomerOwnHave5(newEvent)
                        return field.onChange(newEvent)
                      }}
                    />
                  )}
                </Field>
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
          {selectedCustomerOwnHave5 === true && (
            <>
              <CustomerIsAnInternalRankOwnHave5 />
            </>
          )}
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>Thông tin về chủ sở hữu hưởng lợi</label>
            <div className='d-flex align-items-center'>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  type='checkbox'
                  name='informationAboutoOners'
                  className='form-check-input w-45px h-30px'
                >
                  {({field, form: {touched, errors}}: any) => (
                    <input
                      className='form-check-input w-45px h-30px'
                      {...field}
                      type='checkbox'
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        handleCheckedInfowOwn(newEvent)
                        return field.onChange(newEvent)
                      }}
                    />
                  )}
                </Field>
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
          {selectedCustomerInforOwn === true && (
            <div>
              <div className='mt-4'>
                <Field
                  name='bo_fullname'
                  placeholder='Họ và tên*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_fullname' />
                </div>
              </div>
              <div className='mt-4 temp'>
                <Field
                  name='bo_dob'
                  placeholder='Ngày sinh*'
                  className='form-control form-control-lg form-control-solid'
                >
                  {({field, form: {touched, errors}}: any) => (
                    <DatePicker
                      className='form-control form-control-lg form-control-solid'
                      selected={valueBirth}
                      placeholderText='Ngày sinh*'
                      onKeyDown={(e) => e.preventDefault()}
                      dateFormat='dd/MM/yyyy'
                      onChange={(date: any) => {
                        let newEvent = moment(date).format('YYYY-MM-DD')
                        handleChangeBirth(newEvent)
                        setFieldValue('bo_dob', newEvent)
                      }}
                    />
                  )}
                </Field>
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_dob' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_nationality'
                  placeholder='Quốc tịch*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_nationality' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_idno'
                  placeholder='Số CMND/ CCCD/ Hộ chiếu*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_idno' />
                </div>
              </div>
              <div className='mt-4 temp'>
                <Field
                  name='bo_idno_iss_dt'
                  placeholder='Ngày cấp*'
                  className='form-control form-control-lg form-control-solid'
                >
                  {({field, form: {touched, errors}}: any) => (
                    <DatePicker
                      className='form-control form-control-lg form-control-solid'
                      selected={valueBoIss}
                      placeholderText='Ngày cấp*'
                      onKeyDown={(e) => e.preventDefault()}
                      dateFormat='dd/MM/yyyy'
                      onChange={(date: any) => {
                        let newEvent = moment(date).format('YYYY-MM-DD')
                        handleChangeBoIss(newEvent)
                        setFieldValue('bo_idno_iss_dt', newEvent)
                      }}
                    />
                  )}
                </Field>
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_idno_iss_dt' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_idno_iss_orga'
                  placeholder='Nơi cấp*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_idno_iss_orga' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_home_addr'
                  placeholder='Địa chỉ thường trú*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_home_addr' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_conct_addr'
                  placeholder='Địa chỉ liên hệ*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_conct_addr' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_job'
                  placeholder='Nghề nghiệp*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_job' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_position'
                  placeholder='Chức vụ*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_position' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_phone_no'
                  placeholder='Số điện thoại*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_phone_no' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_visa_no'
                  placeholder='Số thị thực*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_visa_no' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_visano_iss_orga'
                  placeholder='Nơi cấp*'
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='bo_visano_iss_orga' />
                </div>
              </div>
              <div className='mt-4'>
                <Field
                  name='bo_foreign_residence'
                  placeholder='Địa chỉ đăng ký cứ trú ở nước ngoài (nếu có)'
                  className='form-control form-control-lg form-control-solid'
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export {Step10}
